import {Component, OnInit, setTestabilityGetter} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../../services/api.service";
import {ResetPasswordService} from "../services/reset-password.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-reset-password-request',
  templateUrl: './reset-password-request.component.html',
  styleUrls: ['./reset-password-request.component.scss'],
  standalone: false
})
export class ResetPasswordRequestComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Login', path: 'app/login'},
    { label: 'Reset Password', path: 'app/login/reset-password-request'}
  ];
  showSuccessMessages: boolean = false;
  successMessages: any[] = [];
  showErrorMessages: boolean = false;
  errorMessages: any[] = [];

  constructor(private authService: AuthService, private apiService: ApiService,
              private router: Router, private route: ActivatedRoute,
              private resetPasswordService: ResetPasswordService,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Forgot Password")
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }

  showErrorMessagesToUser(): void {
    this.showErrorMessages = true;
    const counterFn = () => {
      this.showErrorMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  showSuccessMessagesToUser(): void {
    this.showSuccessMessages = true;
    const counterFn = () => {
      this.showSuccessMessages = false;
    }
    setTimeout(counterFn, 3000);
  }

  onSubmit(): any {
    this.showErrorMessages = false;
    this.showSuccessMessages = false;
    this.errorMessages = [];
    this.successMessages = [];
    //Obtain email
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email: string = emailEl.value;
    if (!email) {
      this.errorMessages.push({
        field: 'Email',
        detail: 'Email: ' + email + ' is not valid.',
        severity: 'error'
      });
    }
    //contactChannel = EMAIL
    let phoneNumber: string = ''; //Phone numbers are not supported yet.
    let contactChannel: string = 'EMAIL';

    if (this.errorMessages.length > 0) {
      this.showErrorMessagesToUser();
      return;
    }
    this.resetPasswordService.resetPasswordEmail(email, email, phoneNumber, contactChannel).subscribe(
      (result: any) => {
      if (result && result.body) {
        // Display success message of sending email
        this.successMessages.push({
          field: 'Reset Password',
          detail: 'Reset Password Link has been sent successfully.',
          severity: 'success'
        });
        localStorage.setItem('resetPasswordEmail', email);
        this.showSuccessMessagesToUser();
        // 3 second timeout before navigating back to the
        this.router.navigateByUrl('/app/login/reset-password-email-sent');
      }
    },  (error: any) => {
        this.errorMessages.push({
          field: 'Reset Password Request',
          detail: 'Failed to send Reset Password Request.',
          severity: 'error'
        })
        this.showErrorMessagesToUser();
        return;
    });
  }

  onCancel(): any {
    this.router.navigateByUrl('/app/login');
  }
}
